import { runtimeEnv } from "@penn/web-common";

import { PennText } from "@/components/ui";
import { customerAppUrl } from "./customer-app-url";

/**
 * Shown instead of the Work-For page when a signed-in user lacks
 * `canWorkForOthers`. Offers the customer app rather than only a sign-out, so
 * an external user who followed a stale link is not stranded here.
 */
export const NoWorkForAccessPage = () => {
  const customerUrl = customerAppUrl(runtimeEnv("VITE_WEB_CUSTOMER_URL"));

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-penn-900 dark:bg-gray-950">
      <div className="text-center max-w-md">
        <PennText as="h1" size="xl" align="center" color="on-navy" font="semibold" className="mb-2">
          You cannot act for another customer
        </PennText>
        <PennText as="p" size="sm" align="center" color="on-navy-secondary" className="mb-8">
          This account does not hold the Work-For permission. If you believe this
          is a mistake, contact your administrator.
        </PennText>
        {customerUrl && (
          <a
            href={customerUrl}
            className="text-sm font-semibold text-white underline hover:text-penn-100"
          >
            Go to the customer app
          </a>
        )}
      </div>
    </div>
  );
};
